import React, { useEffect, useState } from "react";
import "./style.css";
import Admin from "./Admin";
import AdminCash from "./AdminCash";

const API = "https://api.europeanathletic.com";

export default function App() {

  const isAdmin = window.location.pathname.includes("/admin");
  const isCash = window.location.pathname.includes("/admin-cash");

  const [competitions, setCompetitions] = useState([]);
  const [classes, setClasses] = useState([]);
  const [services, setServices] = useState([]);

  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");

  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [allowCash, setAllowCash] = useState(false);

  const [success, setSuccess] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAdmin) return;

    fetch(API + "/api/competitions")
      .then(res => res.json())
      .then(setCompetitions);
  }, [isAdmin]);

  useEffect(() => {
    if (!selectedCompetition) {
      setClasses([]);
      setAllowCash(false);
      return;
    }

    fetch(API + `/api/classes?competition_id=${selectedCompetition}`)
      .then(res => res.json())
      .then(setClasses);

    const comp = competitions.find(c => c.id === Number(selectedCompetition));
    if (comp) {
      setAllowCash(comp.allow_cash || false);
    }

  }, [selectedCompetition, competitions]);

  useEffect(() => {
    if (!selectedCompetition) {
      setServices([]);
      return;
    }

    fetch(API + `/api/services?competition_id=${selectedCompetition}`)
      .then(res => res.json())
      .then(setServices);

  }, [selectedCompetition]);

  useEffect(() => {
    const checkoutId = localStorage.getItem("checkoutId");

    if (!checkoutId) return;

    const checkStatus = async () => {
      try {
        const res = await fetch(API + "/api/payment-status/" + checkoutId);
        const data = await res.json();

        if (data.status === "PAID") {
          localStorage.removeItem("checkoutId");
          setPaymentStatus("SUCCESS");
          setSuccess(true);
        }
      } catch (err) {
        console.error(err);
      }
    };

    checkStatus();
  }, []);

  if (window.location.pathname.includes("/admin-cash")) {
  return <AdminCash />;
}

if (isAdmin) {
  return <Admin />;
}

  const toggleClass = (id) => {
    if (selectedClasses.includes(id)) {
      setSelectedClasses(selectedClasses.filter(c => c !== id));
    } else {
      setSelectedClasses([...selectedClasses, id]);
    }
  };

  const getTotal = () => {
    let total = 0;

    services.forEach(s => {
      if (selectedServices.includes(s.id)) {
        total += Number(s.price);
      }
    });

    if (selectedClasses.length > 2) {
      const extra = selectedClasses.length - 2;
      total += extra * 10;
    }

    return total;
  };

  const isEmailValid = () => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isEmailMatching = () => {
    return email && emailConfirm && email === emailConfirm;
  };

  const isValid = () => {
    return (
      selectedCompetition &&
      selectedClasses.length > 0 &&
      name &&
      email &&
      emailConfirm &&
      isEmailValid() &&
      isEmailMatching() &&
      (services.length === 0 || selectedServices.length > 0) &&
      acceptedTerms
    );
  };

  const resetForm = () => {
    setSelectedCompetition(null);
    setSelectedClasses([]);
    setSelectedServices([]);
    setName("");
    setEmail("");
    setEmailConfirm("");
    setAllowCash(false);
    setLoading(false);
    setAcceptedTerms(false);
  };

  // ==============================
  // PAYMENT
  // ==============================
  const payCard = async () => {

    if (loading) return;

    setLoading(true);

    try {
      const res = await fetch(API + "/api/payment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          competition_id: selectedCompetition,
          customer_name: name,
          email: email,
          items: [
            ...selectedClasses.map(id => ({
              type: "class",
              ref_id: id
            })),
            ...selectedServices.map(id => ({
              type: "service",
              ref_id: id
            }))
          ]
        }),
      });

      const data = await res.json();

      if (data.checkout_url) {
        localStorage.setItem("checkoutId", data.checkout_id);
        window.location.href = data.checkout_url;
      } else {
        setLoading(false);
        setPaymentStatus("FAILED");
        setSuccess(true);
      }

    } catch (err) {
      console.error(err);
      setLoading(false);
      setPaymentStatus("FAILED");
      setSuccess(true);
    }

  };

  const payCash = async () => {
    await fetch(API + "/api/orders", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        competition_id: selectedCompetition,
        customer_name: name,
        email: email,
        items: [
          ...selectedClasses.map(id => ({
            type: "class",
            ref_id: id
          })),
          ...selectedServices.map(id => ({
            type: "service",
            ref_id: id
          }))
        ],
        payment_type: "CASH"
      }),
    });

    setPaymentStatus("SUCCESS");
    setSuccess(true);
  };

  if (success) {
    return (
      <div style={styles.container}>
        {paymentStatus === "SUCCESS" && (
          <h1 style={{ textAlign: "center" }}>Zahlung erfolgreich</h1>
        )}

        {paymentStatus === "FAILED" && (
          <h1 style={{ textAlign: "center", color: "red" }}>
            Zahlung fehlgeschlagen
          </h1>
        )}

        <button
          style={{ ...styles.button, marginTop: 20 }}
          onClick={() => {
            resetForm();
            setSuccess(false);
            setPaymentStatus(null);
          }}
        >
          Neue Buchung
        </button>
      </div>
    );
  }

  return (
    <div className="container" style={styles.container}>
      <h1 style={styles.title}>Order your Media Package</h1>

      {loading && (
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          Zahlung wird vorbereitet...
        </div>
      )}

      <div style={styles.section}>
        <h2>Competition</h2>
        <select style={styles.input} value={selectedCompetition || ""} onChange={(e) => {
          setSelectedCompetition(Number(e.target.value));
          setSelectedClasses([]);
          setSelectedServices([]);
        }}>
          <option value="">Select Competition</option>
          {competitions.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      <div style={styles.section}>
        <h2>Additional Services</h2>
        <select style={styles.input} value={selectedServices[0] || ""} onChange={(e) => {
          const value = Number(e.target.value);
          if (!value) {
            setSelectedServices([]);
            return;
          }
          setSelectedServices([value]);
        }}>
          <option value="">Service auswählen</option>
          {services.map(s => (
            <option key={s.id} value={s.id}>{s.name} (€{s.price})</option>
          ))}
        </select>
      </div>

      <div style={styles.section}>
        <h2>Choose your Classes</h2>
        <div style={styles.grid}>
          {classes.map(c => (
            <label key={c.id} style={styles.classItem}>
              <input
                type="checkbox"
                checked={selectedClasses.includes(c.id)}
                onChange={() => toggleClass(c.id)}
              />
              {c.name}
            </label>
          ))}
        </div>
      </div>

      <div style={styles.section}>
        <h2>Your Details</h2>
        <input style={styles.input} placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} />
        <input style={styles.input} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input style={styles.input} placeholder="Confirm Email" value={emailConfirm} onChange={(e) => setEmailConfirm(e.target.value)} />
      </div>

      <div style={styles.section}>
        <h2>Total: €{getTotal()}</h2>
      </div>

      {/* ✅ AGB */}
      <div style={{ marginBottom: 20 }}>
        <label>
          <input
            type="checkbox"
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
          />
          {" "}Ich akzeptiere die{" "}
          <a href="https://europeanathletic.com/agb/" target="_blank">
            AGB
          </a>{" "}
          und die{" "}
          <a href="https://europeanathletic.com/privacy-policy/" target="_blank">
            Datenschutzerklärung
          </a>
        </label>
      </div>

      <div style={{ display: "flex", gap: 10 }}>
        <button style={styles.button} disabled={!isValid()} onClick={payCard}>
          Pay with Card
        </button>


      </div>

    </div>
  );
}

const styles = {
  container: { maxWidth: 800, margin: "auto", padding: 30, fontFamily: "Arial" },
  title: { textAlign: "center", marginBottom: 40 },
  section: { marginBottom: 40 },
  grid: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 },
  classItem: { border: "1px solid #ddd", padding: 10, borderRadius: 8, display: "flex", gap: 8 },
  input: { width: "100%", padding: 12, marginBottom: 10, borderRadius: 6, border: "1px solid #ccc" },
  button: { flex: 1, padding: 15, fontSize: 16, background: "black", color: "white", border: "none", borderRadius: 8, cursor: "pointer" }
};
